import CourseCard from "./components";

export default CourseCard;
